module.exports = __webpack_public_path__ + "img/flex-pirate-ship-sm.f407e0cb.svg";